import React from 'react'
import { withRouter } from 'react-router-dom'

import { CampaignView } from 'Components/ClientDashboard'

const ClientCampaigns = props => {
  const {
    client,
    match: {
      params: { type, subType },
    },
  } = props
  return <CampaignView client={client} type={type} subType={subType} />
}

export default withRouter(ClientCampaigns)
